<mat-card class="modal-wrapper">
  <mat-card-header class="pb-4">
    <mat-card-title higherFont [innerHTML]="data.title"></mat-card-title>
  </mat-card-header>
  <mat-card-content [innerHTML]="data.message"></mat-card-content>

  <div mat-dialog-actions class="actions d-flex justify-content-end mt-4">
    <ng-container *ngIf="data.actions?.length; else defaultActions">
      <ng-container *ngFor="let action of data.actions">
        <button
          gdClarityUnmask
          *ngIf="action.appearance === 'raised'; else nonRaisedAction"
          mat-raised-button
          [color]="action.color"
          type="button"
          [attr.cdkFocusInitial]="action.autoFocus ? '' : null"
          (click)="onAction(action.value)"
        >
          {{ action.text }}
        </button>
        <ng-template #nonRaisedAction>
          <button
          gdClarityUnmask
            *ngIf="action.appearance === 'stroked'; else basicAction"
            mat-stroked-button
            [color]="action.color"
            type="button"
            [attr.cdkFocusInitial]="action.autoFocus ? '' : null"
            (click)="onAction(action.value)"
          >
            {{ action.text }}
          </button>
        </ng-template>
        <ng-template #basicAction>
          <button
          gdClarityUnmask
            mat-button
            [color]="action.color"
            type="button"
            [attr.cdkFocusInitial]="action.autoFocus ? '' : null"
            (click)="onAction(action.value)"
          >
            {{ action.text }}
          </button>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-template #defaultActions>
      <button mat-button gdClarityUnmask type="button" (click)="onRejectAction()">
        {{ data.rejectText || "Cancelar" }}
      </button>
      <button
          gdClarityUnmask
        mat-raised-button
        color="primary"
        type="button"
        (click)="onAcceptAction()"
      >
        {{ data.acceptText || "Aceptar" }}
      </button>
    </ng-template>
  </div>
</mat-card>
